// @flow

const localStorageAvailable = (): boolean =>
  typeof window === 'object' && typeof Storage === 'function';

export const setItem = (name: string, value: any, json: boolean = true) => {
  if (!localStorageAvailable()) return undefined;
  try {
    window.localStorage.setItem(name, json ? JSON.stringify(value) : value);
  } catch (e) {
    // swallowing the "this operation is insecure" error from Safari w/ cookies disabled
    return undefined;
  }
  return true;
};

export const getItem = (name: string) => {
  if (!localStorageAvailable()) return undefined;
  let item;
  try {
    item = window.localStorage.getItem(name);
  } catch (e) {
    // swallowing the "this operation is insecure" error from Safari w/ cookies disabled
    return undefined;
  }
  try {
    return JSON.parse(item);
  } catch {
    return item;
  }
};

export const removeItem = (name: string): ?boolean => {
  if (!localStorageAvailable()) return undefined;
  try {
    window.localStorage.removeItem(name);
  } catch (e) {
    // swallowing the "this operation is insecure" error from Safari w/ cookies disabled
    return undefined;
  }

  return true;
};
